// Written by scripts/generate-blog-og-images.mjs during prebuild. Do not edit.
// slug -> content hash of the blog OG card. The hash is appended as `?v=` so a
// changed card gets a new URL (cards are cached for a year, see public/_headers).
export const blogOgHashes = {
  "microsoft-security-best-practices-2025": "d72095e3aff2f8bc",
  "hardening-active-directory": "68f01234cddf4ab7",
  "entra-id-migration-strategy": "a59350ef55e094e1",
  "copilot-security-training": "f122c06c2c16076c",
  "acsc-essential-eight-complete-2025-guide": "fa26b97816e53bed",
  "application-whitelisting-technical-implementation": "7c9179c7d4f3b7cd",
  "security-culture-foundations-building-human-firewall": "ab9eb514d7a19c9f",
  "acsc-essential-eight-assessment-guide": "ca314628595595d5",
  "essential-eight-fundamentals-course-overview": "3c04a7edccae6bfd",
  "essential-eight-patch-management-automation": "aa62860cefbc3eb2",
  "azure-ad-security-best-practices-2025": "4592863753f40f8e",
  "conditional-access-policies-zero-trust": "e04a345d3a85f2ca",
  "passwordless-authentication-azure-ad": "d2eff10fc5926a02",
  "azure-ad-hybrid-identity-architecture": "ef42e626fdd59f81",
  "advanced-ad-administration-course": "1b11dfae19deac2f",
  "security-culture-maturity": "c4e11169d8714a5a",
  "phishing-simulations-security-behavior-change": "9af27a0606d4d083",
  "security-champions-programs-peer-learning": "0dee615d206b2d58",
  "security-training-roi-analysis-business-case": "479fb192cf44f2ef",
  "microsoft-365-security-hardening-course": "be8caabb74b5574c",
  "iso-27001-2022-implementation-roadmap": "c06d092e812745c5",
  "iso-27001-annex-a-12-operations-security": "fc2973a2adf4fd43",
  "iso-27001-vs-acsc-essential-eight-framework-mapping": "19aacca13f5f879e",
  "security-assessment-roi-case-study-australian-organisation": "e26642cd1440bbc7",
  "compliance-governance-training-course-overview": "609018742705f883",
  "australian-security-trends-2025": "23788228837d6727",
  "essential-eight-control-7-mfa-best-practices": "04a1d4179adc5251",
  "essential-eight-control-5-user-privilege-management": "cd3a5b4101723e35",
  "os-hardening-windows-11-security": "43f3e54156bcb2cc",
  "application-hardening-browser-office-security": "b31786b41324a36e",
  "system-monitoring-logging-siem": "0a604ed86cfd2160",
  "regular-backups-recovery-essential-eight": "6121dc1040af1e52",
  "privacy-act-1988-compliance-guide-australian-organisations": "2ae21a542dde583d",
  "incident-response-planning-template": "b22b5245d76122ea",
  "third-party-risk-management-vendor-security": "fccc3b757190d074",
  "security-culture-foundations-building-workforce-ready-acsc": "8941f92227532145",
  "conditional-access-policies-for-zero-trust": "982373364d403191",
  "beyond-standard-sharepoint-sam-governance-puzzle": "32929707791bf692",
  "hardening-hub-sam-stop-data-over-sharing-2026": "244d48ca8da73c7c",
  "content-copilot-ready-sharepoint-advanced-management": "e5105b4642c1c89d",
  "sam-licensing-decoded-maximising-roi-m365-2026": "b764f4d4bdf01a64",
  "sam-masterclass-ebook-governing-m365-in-the-age-of-copilot": "9114095e000a12f3",
  "educ4te-training-advisory-capabilities-showcase": "fd05eb39bc3da76e",
  "essential-eight-maturity-level-2-2026-evidence-pack": "b99471f7f32e2778",
  "essential-eight-ml2-evidence-templates-per-control": "a0a90acc7aae5a81",
  "application-control-microsoft-365-applocker-wdac-ml2": "2f1ec22d9ffe701c",
  "mapping-microsoft-365-copilot-asd-essential-eight-maturity-level-2-2026": "74a05b69b8e6fe92",
  "application-control-copilot-studio-agents": "0cf5b3502cb8ae3f",
  "essential-eight-evidence-pack-irap-format-checklist-copilot-scope": "d44ea0a1175d807c",
  "ad-tier-model-essential-eight-ml2-recovery-australia": "47d52eff4dfd556d",
  "tier-0-isolation-hybrid-active-directory": "8dac7b4caafa5dfe",
  "active-directory-backup-verification-forest-recovery-rehearsal": "db70392c0193e08b",
  "hybrid-ad-to-entra-cutover-walkthrough": "716abea4d083c2cc",
  "golden-ticket-detection-active-directory": "b73fe93c87dc976b",
  "hybrid-ad-entra-cutover-risk-register": "3364eec7d55ac2ac",
  "essential-eight-maturity-level-2-evidence-pack-resource": "48c889ee992c10d8",
  "app-8-anthropic-subprocessor-disclosure-template-resource": "a45f4968c5944cd1",
  "smb-cyber-insurance-evidence-pack-resource": "bdb7cabfcefb24d9",
  "active-directory-recovery-runbook-resource": "5a4fa154ca304089",
  "sharepoint-ia-for-copilot-2026-pillar": "d4976e3d8370c123",
  "sharepoint-2026-retirement-deadline-every-australian-organisation-must-know": "80a39650d68ccdfb",
  "from-2013-workflows-power-automate-3-week-migration-survival-guide": "270de8de7eb998bf",
  "infopath-end-of-life-powerapps-migration-strategies-australian-compliance": "4d5fc202110ffa6f",
  "sharepoint-hybrid-cloud-only-2026-decision-framework-australian-enterprises": "02a0806272fe5124",
  "new-sharepoint-online-experience-what-changed-why-cisos-should-care": "867193e148f88ac3",
  "sharepoint-server-subscription-edition-on-premises-path-2026": "2bc0cc13250c74a3",
  "microsoft-purview-sharepoint-governance-transition-compliance-officers": "852fd6bbceb5fd98",
  "file-level-archiving-sharepoint-2026-storage-optimisation-without-data-loss": "d5451680bf7f655a",
  "sharepoint-agents-agentic-ai-preparing-environment-autonomous-workflows": "9656d9da40803337",
  "complete-sharepoint-2026-migration-checklist-assessment-to-go-live": "fadceba04894f4db",
  "microsoft-365-copilot-wave-1-australian-guide": "03ebaf66c605a90e",
  "microsoft-365-copilot-wave-2-australian-guide": "d837b7fa463d18e8",
  "microsoft-copilot-researcher-analyst-agents-australia": "fd5c36703ed61cd0",
  "microsoft-copilot-wave-3-australian-briefing": "0b976686ef9d2a16",
  "copilot-agentic-features-apps-2026": "55317d7ca701a127",
  "agent-365-frontier-suite-governance-australia": "9d015cbd20122275",
  "microsoft-purview-copilot-sensitivity-labels-australia": "ed70c34cf0567c90",
  "microsoft-copilot-sharepoint-teams-governance-australia": "a8b2785a251686b2",
  "copilot-cowork-australia-data-residency-gap": "7398adc299ec82e6",
  "microsoft-365-copilot-business-smb-australia": "ef4a75599f79b0e6",
  "microsoft-work-iq-australian-privacy-implications": "da12d1e260b556f6",
  "essential-eight-control-3-microsoft-office-macro-settings": "6c1b1867d6f8122f",
  "azure-ad-privileged-identity-management-jit-access": "23eec256af460fea",
  "azure-ad-b2b-guest-access-governance-australia": "2b8e1ea31c606225",
  "building-incident-reporting-culture-no-blame-framework": "1fc5dab9895772a0",
  "executive-board-security-engagement-cyber-risk-governance": "0a955d94b9d380c4",
  "iso-27001-organisational-people-controls-annex-a5-a6": "a4a4ee9fc9ec222c",
  "iso-27001-internal-audit-continuous-improvement-isms": "210b25187775bbfe",
  "essential-eight-control-2-patch-applications": "e595762c92145be8",
  "essential-eight-control-6-patch-operating-systems": "4c4ec6198dd1fb98",
  "microsoft-secure-score-australian-smbs": "d48d66bee9906e4d",
  "microsoft-365-health-check-60-minutes": "86a07c547e6d0f79",
  "restricted-sharepoint-search-australian-tenants": "6306876480fef2b3",
  "auditing-entra-id-australian-privacy-act": "e069a450792b8f4c",
  "conditional-access-patterns-australian-organisations": "dea0d8ac22c719f2",
  "privileged-identity-management-rollout-playbook": "291acb03a6d4318e",
  "entra-id-access-reviews-implementation": "3995701c295a1f63",
  "entra-id-guest-external-access-hygiene": "6f2a78e68452a056",
  "restricted-sharepoint-search-allow-list-curation-copilot-governance": "a93c65ecee07f276",
  "dspm-for-ai-walkthrough-australian-copilot-rollout": "52477b615cc2e06d",
  "copilot-governance-maturity-model-l1-l5-australia": "26014c9ada187d5b",
  "agent-sprawl-audit-playbook-copilot-control-system": "e19dab17a16766e0",
  "purview-dlp-for-copilot-australian-rollout-pattern": "8d04f6d1ddb8311d",
  "cyber-security-australian-small-business-practical-baseline-2026": "391af4e9722ab02d",
  "ndb-scheme-plain-english-small-business-australia": "23816c8098003cf5",
  "cyber-insurance-underwriting-questions-small-business-australia": "61ce261479794f78",
  "mfa-for-tiny-teams-small-business-australia": "f34ec96f5c5055e0",
  "backup-that-survives-ransomware-small-business-australia": "cbd99cb608386e06",
  "microsoft-365-copilot-wave-3-deployment-playbook-australia": "67a9f36599b2631b",
  "copilot-licensing-maths-australian-organisations": "34022208b4927ed0",
  "copilot-adoption-kpis-first-90-days-australia": "8e453307435e98a1",
  "how-to-read-microsoft-secure-score-dashboard-australian-smb": "5a110538101ad548",
  "microsoft-365-security-defaults-vs-conditional-access-australia": "3aeee4bdd8c6a4d8",
  "how-to-audit-entra-id-guest-accounts-australian-organisations": "cf510f66d48c5983",
  "privileged-identity-management-pim-setup-guide-australia": "103973262f66935f",
  "how-to-implement-active-directory-tier-model-essential-eight-ml2-australia": "ea4d9e89dba90305",
  "active-directory-health-check-powershell-commands-australia": "cf542010e1d4c34f",
  "how-to-prepare-essential-eight-ml2-evidence-pack-australia": "3d92f74e9c78762c",
  "essential-eight-gap-analysis-checklist-2026-australia": "bf03ddfbb446cb2c",
  "cyber-security-checklist-australian-small-business-2026": "ec582f41c73c5bf3",
  "how-to-set-up-mfa-microsoft-365-small-business-australia": "c4972d4599608515",
  "how-to-configure-restricted-sharepoint-search-microsoft-365-copilot": "aea30828df898db4",
  "microsoft-teams-governance-policy-template-australian-organisations": "e7af37a0186fd0a8",
  "how-to-run-microsoft-365-copilot-pilot-program-australia": "0c4f1884238d9ac8",
  "copilot-deployment-readiness-checklist-australia-2026": "aff0f6ee704f6710",
  "how-to-configure-microsoft-purview-sensitivity-labels-copilot-australia": "c8bddef484c7789e",
  "copilot-data-governance-policy-template-australian-organisations": "2b72f39f43608e9a",
  "how-to-align-microsoft-365-copilot-essential-eight-controls-australia": "fe2b9dab61c90e13",
  "copilot-application-control-patch-management-essential-eight-australia": "27372817fa50712c",
  "mfa-attestation-australian-smbs-insurance-compliance": "e5a11294acae038a",
  "smb-essential-eight-playbook-maturity-level-2-australia": "f5fa6e9be19b6580",
  "copilot-studio-2026-release-wave-australia": "1150690741849621",
  "asd-blueprint-copilot-configuration-australia": "7957c3f8a0a03aa0",
  "microsoft-365-copilot-australia-data-residency-irap": "88d76e2ade493613",
  "copilot-security-roadmap-essential-eight-australia": "524f37632d9571e2",
  "microsoft-365-features-agents-enabled-by-default-governance": "a75a559d01f7baa0",
  "microsoft-copilot-agentic-ai-governance-australia": "4e0c8432fe6028f2",
  "five-permission-checks-sharepoint-site-owners-copilot": "6d0b567a9a88499c",
  "two-organisations-one-microsoft-365-tenant-content-boundary": "b6ef806b5711214f",
  "sharepoint-restricted-access-control-site-permissions-not-enough": "99beb36c7777cdf1",
  "entra-entitlement-management-teams-sharepoint-access-two-organisations": "17b2c05a26e477df",
  "onedrive-channel-sites-applications-content-boundary-edge-cases": "bce88b301183b841",
  "copilot-agent-credentials-user-maker-agent-identity": "6b30e1ef7dbcea1b",
  "copilot-agent-knowledge-sharepoint-access-path": "714d1220b9ef7315",
  "copilot-agent-tools-connectors-triggers-writes": "1aafea24dff9a7d2",
  "pilot-design-test-shared-tenant-content-boundary": "b1317b65d0bfeb27",
  "prompt-injection-action-capable-copilot-agent": "83fb4ad55fce4351",
  "audit-trail-after-copilot-agent-acts": "0d475c106ad25ea9",
  "copilot-readiness-report-dspm-inventory-cannot-tell-you": "175ceea964254f8d",
  "negative-testing-copilot-cannot-reach": "b070aa5d5ccf956e",
  "what-is-microsoft-365-local-workloads": "2b1426a57590dd63",
  "microsoft-365-local-vs-cloud-when-local-makes-sense": "bc51be9523aa73f1",
  "connected-disconnected-operational-boundary": "414dbed63e6b2ba2",
  "identity-privileged-access-microsoft-365-local": "7b1691b270e8b04f",
  "security-governance-controls-microsoft-365-local": "dbe1eec8f24f82b2",
  "patching-backup-recovery-without-cloud-connectivity": "dcddda3adde127a3",
  "microsoft-365-local-costs-licensing-partner-readiness": "3fcdd2bd6f2dde9d"
};
